import { render, staticRenderFns } from "./UninstallHelp.vue?vue&type=template&id=0148dd7d&scoped=true&"
import script from "./UninstallHelp.vue?vue&type=script&lang=ts&"
export * from "./UninstallHelp.vue?vue&type=script&lang=ts&"
import style0 from "./UninstallHelp.vue?vue&type=style&index=0&id=0148dd7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148dd7d",
  null
  
)

export default component.exports